import React, { useContext, useState, useEffect } from 'react';
import styled from 'styled-components';

import ThemeContext from '../contexts/ThemeContext';

import i18n from '../i18n';

const StyledStatusContainer = styled.div`
  text-align: center;
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 10px;
  padding: 8px 2px;
`;

const StyledStatusBadge = styled.span`
  font-size: ${({ fontSize }) => (fontSize)}px;
  color: ${({ color }) => color};
`;

// Shared with the interpreter calendar so a cancelled booking tile looks like the cancelled status badge (TUL-5839).
// The tile colours are opaque equivalents of the badge background on white, so overlapping tiles do not show through.
export const cancelledStatusColors = {
  backgroundColor: 'rgba(234, 126, 143, 0.2)',
  tileBackgroundColor: '#FBE5E9',
  tileHoverBackgroundColor: '#F8D3D9',
  borderColor: '#EA7E8F',
  color: '#6f313aff',
};

const StatusBadge = ({ status }) => {
  const { layout } = useContext(ThemeContext);

  const [propsByStatus] = useState({
    confirmed: {
      key: 'confirmed',
      styles: {
        backgroundColor: '#eafee6',
        color: '#14771eff'
      }
    },
    ongoing: {
      key: 'ongoing_prebooking',
      styles: {
        backgroundColor: '#e6f2ff',
        color: '#0b3d91'
      }
    },
    pending: {
      key: 'unconfirmed_prebooking',
      styles: {
        backgroundColor: '#fff3e7',
        color: '#76410fff'
      }
    },
    completed: {
      key: 'completed_prebooking',
      styles: {
        backgroundColor: '#eafee6',
        color: '#14771eff'
      }
    },
    delivered: {
      key: 'delivered',
      styles: {
        backgroundColor: '#eafee6',
        color: '#14771eff'
      }
    },
    not_able_to_reach: {
      key: 'not_able_to_reach',
      styles: {
        backgroundColor: '#fff3e7',
        color: '#6f313aff'
      }
    },
    cancelled: {
      key: 'cancelled',
      styles: {
        backgroundColor: cancelledStatusColors.backgroundColor,
        color: cancelledStatusColors.color
      }
    },
  });
  const [currentStatus, setCurrentStatus] = useState(() => propsByStatus[status] || propsByStatus.pending);

  useEffect(() => {
    setCurrentStatus(propsByStatus[status] || propsByStatus.pending);
  }, [propsByStatus, status]);

  return (
    <StyledStatusContainer
      backgroundColor={currentStatus.styles.backgroundColor}
    >
      <StyledStatusBadge
        fontSize={layout.smallFontSize}
        color={currentStatus.styles.color}
      >
        {i18n(currentStatus.key)}
      </StyledStatusBadge>
    </StyledStatusContainer>
  );
};

export default StatusBadge;
